import React, { InputHTMLAttributes, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FieldWrapper, InputBox, Label, Unit, Slider, SliderWrap, FieldWrapperSlider } from './style';
import Input from 'components/Basic/Input';
import { debounce } from '../../../util';

type BaseInputProps = InputHTMLAttributes<HTMLInputElement>;
interface SliderInputFieldProps extends BaseInputProps {
  label: string;
  unit?: string;
	showSlider?: boolean;
  isActive?: boolean;
  onActivate?: () => void;
	onInputChange: (val: number) => void;
	showError?: boolean;
	onErrorChange?:(e: boolean)=>void

}

const SliderInputField = (props: SliderInputFieldProps) => {
	const {
		id,
		label,
		value,
		min,
		max,
		step = 1,
		unit,
		showSlider = true,
		onInputChange,
		disabled = false,
		onActivate,
		isActive,
		showError= true,
		onErrorChange
	} = props;

	const [localValue, setLocalValue] = useState<string>(String(value));

	// const displayValue = localValue !== null ? localValue : String(value);
	const [isError, setIsError] = useState(false);

	const debouncedChange = useMemo(
		() => debounce(onInputChange),[onInputChange]);

	const validate = (num: number) => {
		if (isNaN(num)) return true;

		if (
			showError &&
    ((min !== undefined && num < +min) ||
      (max !== undefined && num > +max))
		) {
			return true;
		}

		return false;
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const val = e.target.value;

		setLocalValue(val);

		const num = Number(val);
		const error = validate(num);

		setIsError(error);
		onErrorChange?.(error);

		if (!error) {
			debouncedChange(num);
		}
	};
	const handleSliderChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const num = Number(e.target.value);
		setIsError(false);
		onErrorChange?.(false);
		setLocalValue(String(num));
		onInputChange(num);
	}, [onErrorChange, onInputChange]);

	useEffect(() => {
		setLocalValue(String(value));
	}, [value]);

	return (
		<FieldWrapperSlider className={`${isActive ? 'active' : ''} ${showError && isError ? 'error' : ''}`}>
			<FieldWrapper>
				<Label>{label}</Label>
				<InputBox
					onClick={onActivate}
				>
					<Input
						id={id}
						type="number"
						value={localValue}
						min={min}
						max={max}
						step="any"
						disabled={disabled}
						onChange={handleInputChange}
						onFocus={onActivate}
					/>
					{unit && <Unit>{unit}</Unit>}
				</InputBox>
			</FieldWrapper>
			{(showSlider && isActive) && (
				<SliderWrap>
					<Slider
						type="range"
						min={min}
						max={max}
						step={step}
						value={value}
						$value={Number(value)}
						$min={Number(min)}
						$max={Number(max)}
						onChange={handleSliderChange}
						disabled={disabled}
					/>
				</SliderWrap>
			)}
		</FieldWrapperSlider>	
	);
};

export default SliderInputField;
